/**
 * Royal Zanzibar Beach Resort campaign media under /public/campaigns/royal-zanzibar/.
 * Source: official property site https://www.royalzanzibar.com/
 */
export const ROYAL_ZANZIBAR_HERO_IMAGE = "/campaigns/royal-zanzibar/hero-resort.jpg";

export const ROYAL_ZANZIBAR_PROMO_VIDEO = null;

const LOCAL_GALLERY = [
  { file: "hero-resort.jpg", altHe: "Royal Zanzibar Beach Resort — חוף נונגווי" },
  { file: "gallery-02.jpg", altHe: "Royal Zanzibar — בריכות וים" },
  { file: "gallery-03.jpg", altHe: "Royal Zanzibar — שטח הריזורט" },
  { file: "gallery-04.jpg", altHe: "Royal Zanzibar — אווירת ריזורט" },
  { file: "gallery-05.jpg", altHe: "Royal Zanzibar — נוף לאוקיינוס ההודי" },
  { file: "gallery-06.jpg", altHe: "Royal Zanzibar — בריכת המלון" },
  { file: "gallery-07.jpg", altHe: "Royal Zanzibar — חדר Superior Deluxe" },
  { file: "gallery-08.jpg", altHe: "Royal Zanzibar — The Cliff" },
];

export const ROYAL_ZANZIBAR_LOCAL_GALLERY_IMAGES = LOCAL_GALLERY.map((image, index) => ({
  id: `gallery-${index + 1}`,
  file: image.file,
  src:
    index === 0
      ? ROYAL_ZANZIBAR_HERO_IMAGE
      : `/campaigns/royal-zanzibar/${image.file}`,
  altHe: image.altHe,
}));
